import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
`;

export const Field = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: ${({ theme }) => theme.THEME.white};
  font-size: clamp(16px, ${({ theme }) => theme.CONSTANTS.XR * 24}px, 22px);
  font-family: "Inter", sans-serif;

  &::placeholder {
    color: ${({ theme }) => theme.THEME.grayText};
    opacity: 0.7;
  }

  &:focus {
    outline: none;
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px ${({ theme }) => theme.THEME.background}
      inset !important;
    -webkit-text-fill-color: ${({ theme }) => theme.THEME.white} !important;
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;
